import { useQuery } from '@tanstack/react-query';

import { seasonInfoKeys } from '@/hooks/teamLeagueSeasonInfo/seasonInfoKeys';
import { getTeamLeagueSeasonInfoController } from '@/interface-adapters/controllers/get-team-league-season-info.controller';
import { useOrganizationStore } from '@/store/organization-store';

export const useSeasonInfoQuery = (teamLeagueUuid: string) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: seasonInfoKeys.seasonInfo(store.organizationUuid, teamLeagueUuid),
		queryFn: () => getTeamLeagueSeasonInfoController(teamLeagueUuid, store.organizationUuid),
		enabled: !!teamLeagueUuid && !!store.organizationUuid
	});
};
